import { createCrudActions } from '../utils/crudGenerator';

const formatReports = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchReports,
    create: createReport,
    update: updateReport,
    delete: deleteReports
} = createCrudActions('REPORT', "Informe", formatReports);
